import api from './api';

const projectsDashboardService = {
  // Get projects dashboard statistics
  getDashboardStats: async () => {
    try {
      const response = await api.get('/projects-dashboard/stats');
      return response.data;
    } catch (error) {
      console.error('Error fetching projects dashboard stats:', error);
      throw error;
    }
  }
};

export default projectsDashboardService;

